import { apiSlice } from '../../api/apiSlice';

export const qSetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getResourceSets: builder.mutation({
      query: () => ({
        url: 'QSet',
        method: 'GET',
        credentials: 'include'
      })
    }),
    createResourceSet: builder.mutation({
      query: (options) => ({
        url: 'QSet',
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: {...options}
      })
    }),
    moveQSetDocument: builder.mutation({
      query: (option) => ({
        url: `QSet?setId=${option.setId}&sourceIndex=${option.sourceIndex}&destinationIndex=${option.destinationIndex}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getQuestionSets: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.skip}/${options.take}`,
        method: 'POST',
        credentials: 'include',
        body: options
      })
    }),
    deleteQuestionSets: builder.mutation({
      query: (options) => ({
        url: `QSet?isRestore=${options.isRestore}`,
        method: 'DELETE',
        credentials: 'include',
        body: options.ids
      })
    }),
    renameQuestionSet: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.id}/Rename?description=${options.description}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    addLabelsToQuestionSets: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.id}/AddLabels`,
        method: 'PUT',
        credentials: 'include',
        body: options.labels
      })
    }),
    getQuestionSetProperties: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.id}/Properties`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    exportQuestionSetsToXml: builder.mutation({
      query: (options) => ({
        url: 'QSet/ExportToXml',
        method: 'POST',
        credentials: 'include',
        body: options.ids
      })
    }),
    transferQuestionSetsToTeacher: builder.mutation({
      query: (options) => ({
        url: `QSet/TransferToTeacher/?teacherId=${options.teacherId}`,
        method: 'PUT',
        credentials: 'include',
        body: options.ids
      })
    }),
    transferQuestionSetsToAdmin: builder.mutation({
      query: (options) => ({
        url: `QSet/TransferToAdmin/?adminId=${options.adminId}`,
        method: 'PUT',
        credentials: 'include',
        body: options.ids
      })
    }),
    getTagNodes: builder.mutation({
      query: (option) => ({
        url: `Tag/Nodes?node=${option.node}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAttributeNodes: builder.mutation({
      query: (option) => ({
        url: `Attribute/Nodes?node=${option.node}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getStandardNodes: builder.mutation({
      query: (option) => ({
        url: `Standard/Nodes?node=${option.node}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getTopicNodes: builder.mutation({
      query: (option) => ({
        url: `Topic/Nodes?node=${option.node}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    saveMcFillInQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.id}/McFillInQuestion`,
        method: 'POST',
        credentials: 'include',
        body:{...option.params}
      })
    }),
    addCastleQuestionsToQSet: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.id}/CastleQuestions`,
        method: 'POST',
        credentials: 'include',
        body: option.selectedQuestions
      })
    }),
    addSetsToQSet: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.id}/ReadingSetQuestions`,
        method: 'POST',
        credentials: 'include',
        body: options.setIds
      })
    }),
    addRandomMathSkillToQSet: builder.mutation({
      query: (options) => (
        {
          url: `QSet/${options.id}/RandomMathSkillQuestions`,
          method: 'POST',
          credentials: 'include',
          body: options.params
        }
      )
    }),
    addMathSkillQuestionsToQSet: builder.mutation({
      query: (options) => (
        {
          url: `QSet/${options.id}/MathSkillQuestions?courseId=${options.courseId}`,
          method: 'POST',
          credentials: 'include',
          body: options.questionIds
        }
      )
    }),
    GetQSetDetails: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/details`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    GetQuestionPreview: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/Questions/${option.questionNo}?languageId=${option.languageId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    DeleteQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/Question/${option.questionId}`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    GetQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/question/${option.questionId}?courseId=${option.courseId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    UpdateQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/Question/${option.id}/McFillInQuestion`,
        method: 'PUT',
        credentials: 'include',
        body:option
      })
    }),
    saveCRQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.id}/CRQuestion`,
        method: 'POST',
        credentials: 'include',
        body:{...option.params}
      })
    }),
    updateCRQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/Question/${option.id}/CRQuestion`,
        method: 'PUT',
        credentials: 'include',
        body:option
      })
    }),
    moveQsetQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/MoveQsetQuestion`,
        method: 'PUT',
        credentials: 'include',
        body: option.questionIds
      })
    }),
    duplicateCLOQuestionForEdit: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/Question/${option.questionId}/DuplicateCLOQuestionForEdit?courseId=${option.courseId}`,
        method: 'POST',
        credentials: 'include',
        body: option.questionIds
      })
    }),
    renameQuestionDocument: builder.mutation({
      query: (option) => ({
        url: `QSet/QuestionDocument/${option.documentId}?documentName=${option.name}`,
        method: 'PUT',
        credentials: 'include',
      })
    })
  })
});

export const {
  useGetResourceSetsMutation,
  useCreateResourceSetMutation,
  useMoveQSetDocumentMutation,
  useGetQuestionSetsMutation,
  useDeleteQuestionSetsMutation,
  useRenameQuestionSetMutation,
  useAddLabelsToQuestionSetsMutation,
  useGetQuestionSetPropertiesMutation,
  useExportQuestionSetsToXmlMutation,
  useTransferQuestionSetsToTeacherMutation,
  useTransferQuestionSetsToAdminMutation,
  useGetTagNodesMutation,
  useGetAttributeNodesMutation,
  useGetStandardNodesMutation,
  useGetTopicNodesMutation,
  useSaveMcFillInQuestionMutation,
  useAddCastleQuestionsToQSetMutation,
  useAddSetsToQSetMutation,
  useAddRandomMathSkillToQSetMutation,
  useAddMathSkillQuestionsToQSetMutation,
  useGetQSetDetailsMutation,
  useGetQuestionPreviewMutation,
  useDeleteQuestionMutation,
  useGetQuestionMutation,
  useUpdateQuestionMutation,
  useSaveCRQuestionMutation,
  useUpdateCRQuestionMutation,
  useMoveQsetQuestionMutation,
  useDuplicateCLOQuestionForEditMutation,
  useRenameQuestionDocumentMutation
} = qSetApi;